import { render } from "./Index.vue?vue&type=template&id=0c1665ae&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0c1665ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c1665ae"

export default script